module.exports = __webpack_public_path__ + "img/img21.d527d3c6.svg";